<div class="bg-dark fill-height browser-blocker-container">
  <div class="logo-icon-container">
    <mat-icon svgIcon="local:rain-logo" class="white-logo"></mat-icon>
  </div>
  <div>
    RAIN is not supported on this browser type. <br />
    Open RAIN in Google Chrome.
  </div>
</div>
